import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import PermissionErrorPage from '../../pages/PermissionError'

const PermissionErrorRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={path} component={PermissionErrorPage} />
    </Switch>
  )
}

export default PermissionErrorRoute
